import { render, staticRenderFns } from "./track.vue?vue&type=template&id=8589545e&"
import script from "./track.vue?vue&type=script&lang=ts&"
export * from "./track.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports